import {
    CREATE_INVENTORY_ADJUSTMENT,
    LIST_ALL_INVENTORY,
    LIST_INVENTORY_ADJUSTMENT_TYPES,
    LIST_INVENTORY_ENTRIES,
    LIST_MANUFACTURERS,
    STORE_ALL_INVENTORY,
    UPDATE_FTL_RECEIVE,
    STORE_INVENTORY_ADJUSTMENT_TYPES,
    SET_RUN_RATE_CALCULATING,
    STORE_INVENTORY_ENTRIES,
    CLEAR_INVENTORY_ENTRIES,
    STORE_MANUFACTURERS,
    STORE_NEW_INVENTORY_ADJUSTMENT,
    STORE_NEW_INVENTORY_ENTRY,
    STORE_NEW_INVENTORY_TRANSFERRED,
    STORE_UPDATED_INVENTORY_ITEM,
    UPDATE_INVENTORY_THRESHOLD,
    RECALCLATE_RUNNING_RATES,
    LIST_ALL_BOX_INVENTORY,
    GET_INVENTORY_SUMMARY_FOR_FTL,
    LIST_ALL_PRODUCT_INVENTORY,
    STORE_ALL_BOX_INVENTORY,
    STORE_INVENTORY_SUMMARY_FOR_FTL,
    STORE_ALL_PRODUCT_INVENTORY,
    LIST_INVENTORY_ALERTS,
    STORE_INVENTORY_ALERTS,
    LIST_ALL_AISLE,
    STORE_ALL_AISLE,
    SAVE_AISLE,
    GET_LATEST_SHORTCODE_LOCATIONS,
    STORE_LATEST_SHORTCODE_LOCATIONS,
    CONFIRM_INVENTORY_COUNT,
    STORE_ALL_SHORTCODE_INVENTORY, GET_ALL_PRODUCT_INVENTORY,
} from '../../constants/inventory';


export const listAllInventory = () => ({
    type: LIST_ALL_INVENTORY
});

export const storeAllInventory = (allInventory) => ({
    type: STORE_ALL_INVENTORY,
    allInventory
});

export const listInventoryAdjustmentTypes = () => ({
    type: LIST_INVENTORY_ADJUSTMENT_TYPES
});

export const storeInventoryAdjustmentTypes = (inventoryAdjustmentTypes) => ({
    type: STORE_INVENTORY_ADJUSTMENT_TYPES,
    inventoryAdjustmentTypes
});

export const setRunRateCalculating = (runRateCalculating) => ({
    type: SET_RUN_RATE_CALCULATING,
    runRateCalculating,
});

export const listManufacturers = () => ({
    type: LIST_MANUFACTURERS
});

export const storeManufacturers = (manufacturers) => ({
    type: STORE_MANUFACTURERS,
    manufacturers
});

export const listInventoryAlerts = (updateAlerts = false, fetchAlertsData = null) => ({
    type: LIST_INVENTORY_ALERTS,
    updateAlerts,
    fetchAlertsData
});

export const storeInventoryAlerts = (alerts) => ({
    type: STORE_INVENTORY_ALERTS,
    alerts
});

export const listAllBoxInventory = (data) => ({
    type: LIST_ALL_BOX_INVENTORY,
    data
});
export const getInventorySummaryForFTL = (data, columnId, callback) => ({
    type: GET_INVENTORY_SUMMARY_FOR_FTL,
    data,
    meta: { columnId },
    callback
});

export const storeAllBoxInventory = (boxes) => ({
    type: STORE_ALL_BOX_INVENTORY,
    boxes
});

export const storeInventorySummaryForFTL = (summary, columnId) => ({
  type    : STORE_INVENTORY_SUMMARY_FOR_FTL,
  payload : summary,
  meta    : { columnId },
});

export const listAllProductInventory = (data) => ({
    type: LIST_ALL_PRODUCT_INVENTORY,
    data
});

export const storeAllProductInventory = (products) => ({
    type: STORE_ALL_PRODUCT_INVENTORY,
    products
});

////////////////////////////////////////

export const createInventoryAdjustment = (inventoryAdjustment, data, isProducts, selectedLocationData) => ({
    type: CREATE_INVENTORY_ADJUSTMENT,
    inventoryAdjustment,
    data,
    isProducts,
    selectedLocationData
});

export const updateFTLReceive = (transferId, fromDate, toDate, data, isProducts, selectedLocationData) => ({
    type: UPDATE_FTL_RECEIVE,
    transferId,
    fromDate,
    toDate,
    data,
    isProducts,
    selectedLocationData
});

export const storeNewInventoryAdjustment = (inventoryAdjustment) => ({
    type: STORE_NEW_INVENTORY_ADJUSTMENT,
    inventoryAdjustment
});

export const storeNewInventoryTransferred = (inventoryTransferred) => ({
    type: STORE_NEW_INVENTORY_TRANSFERRED,
    inventoryTransferred
});


export const storeNewInventoryEntry = (inventoryEntries) => ({
    type: STORE_NEW_INVENTORY_ENTRY,
    inventoryEntries
});

//////////

export const listInventoryEntries = (data) => ({
    type: LIST_INVENTORY_ENTRIES,
    data
});

export const clearInventoryEntries = () => ({
    type: CLEAR_INVENTORY_ENTRIES,
});
export const storeInventoryEntries = (data) => ({
    type: STORE_INVENTORY_ENTRIES,
    data
});

//
export const updateInventoryThreshold = (inventoryItem, data) => ({
    type: UPDATE_INVENTORY_THRESHOLD,
    inventoryItem,
    data
})
export const recalculateRunningRates = (callback) => ({
    type: RECALCLATE_RUNNING_RATES,
    callback
})

export const storeUpdatedInventoryItem = (updatedInventoryItem) => ({
    type: STORE_UPDATED_INVENTORY_ITEM,
    updatedInventoryItem
})

export const listAllAisle = (data) => ({
    type: LIST_ALL_AISLE,
    data
});

export const storeAllAisle = (aisle) => ({
    type: STORE_ALL_AISLE,
    aisle
});

export const saveAisle = (data) => ({
    type: SAVE_AISLE,
    data
})

export const getShortcodesByLocationForLatestDate = (data) => ({
    type: GET_LATEST_SHORTCODE_LOCATIONS,
    data
});

export const storeLatestShortcodesByLocation = (data) => ({
    type: STORE_LATEST_SHORTCODE_LOCATIONS,
    data
});


export const confirmInventoryCount = (data,reset) => ({
    type: CONFIRM_INVENTORY_COUNT,
    data,
    reset
});

export const getAllProductInventory = () => ({
    type: GET_ALL_PRODUCT_INVENTORY,
});

export const storeAllShortcodeInventory = (products) => ({
    type: STORE_ALL_SHORTCODE_INVENTORY,
    products
});
